import { DecimalUtils, DISPLAY_SCALE } from "../../../../../../libs/utils";
import type { PlanFieldItem } from "../year-card/YearCard";

type RentSumRow = { baseRent?: number | string | null };

export function isBillingScheduleRentSumValid(
  rows: RentSumRow[] | undefined | null,
  annualRent: number | undefined | null,
): boolean {
  if (annualRent == null) return true;

  const totalBaseRent = DecimalUtils.add(rows?.map((row) => row?.baseRent ?? 0) ?? []);
  return DecimalUtils.equals(totalBaseRent, annualRent, { scale: DISPLAY_SCALE });
}

export function getBillingScheduleRentSumErrorMessage(yearNumber: number): string {
  return `Year ${yearNumber}: Sum of base rent must equal the rent value`;
}

export function getBillingScheduleRentSumErrorMessagesForPlans(
  plans: unknown[] | undefined | null,
  options: { isTurnoverRentOnly: boolean },
): string[] {
  if (options.isTurnoverRentOnly || !Array.isArray(plans)) return [];

  return plans.flatMap((raw, index) => {
    const plan = raw as PlanFieldItem;
    const rows = plan.billingScheduleRows;
    if (!rows?.length) return [];

    const yearNumber = plan.noOfYear ?? index + 1;
    const annualRent = plan.annualRent != null ? Number(plan.annualRent) : undefined;

    if (isBillingScheduleRentSumValid(rows, annualRent)) return [];

    return [getBillingScheduleRentSumErrorMessage(yearNumber)];
  });
}
